/* global sponsorFetchUrl sponsorCommitmentStoreUrl */

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import { format, addDays } from 'date-fns';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';

import Button from 'CommonComponents/Button';
import { FormikDatePickerField } from 'CommonComponents/FormikDatePickerField';

const CommittedExpendituresEditSchema = Yup.object().shape({
    contract_reference: Yup.string().nullable(),
    contract_started_at: Yup.string().required($t('This value is required')),
    contract_ended_at: Yup.string().required($t('This value is required')),
});

function SponsorCommitmentModal() {
    const [sponsor, setSponsor] = useState(null);

    useEffect(() => {
        fetchSponsor();
    }, []);

    const fetchSponsor = () => {
        axios.get(sponsorFetchUrl).then(({ data }) => setSponsor(data));
    };

    return (
        <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="sponsorCommitmentModalLabel">
                        {$t('Create Sponsor Contract')} - {sponsor?.name}
                    </h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                {sponsor && (
                    <Formik
                        initialValues={{
                            contract_reference: '',
                            contract_started_at: format(new Date(), 'yyyy/MM/dd'),
                            contract_ended_at: format(addDays(new Date(), 3), 'yyyy/MM/dd'),
                        }}
                        validationSchema={CommittedExpendituresEditSchema}
                        onSubmit={(values, actions) => {
                            axios
                                .post(sponsorCommitmentStoreUrl, { ...values, sponsor_id: sponsor.id })
                                .then((response) => {
                                    window.location.href = sponsorFetchUrl;
                                })
                                .catch((e) => {
                                    e?.response?.data?.errors && actions.setErrors(e.response.data.errors);
                                })
                                .finally(() => {
                                    actions.setSubmitting(false);
                                });
                        }}
                    >
                        {({ errors, touched, isSubmitting, handleSubmit }) => (
                            <>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <label htmlFor="contract_reference">{$t('Contract Reference')}</label>
                                        <Field
                                            type="text"
                                            className={
                                                errors.contract_reference && touched.contract_reference
                                                    ? 'form-control is-invalid border border-danger'
                                                    : 'form-control'
                                            }
                                            name="contract_reference"
                                            placeholder={$t('Contract Reference')}
                                        />
                                        {errors.contract_reference && touched.contract_reference && (
                                            <div className="text-danger">{errors.contract_reference}</div>
                                        )}
                                    </div>
                                    <div className="form-row my-4">
                                        <div className="col-md-6 form-group">
                                            <label htmlFor="contract_started_at">
                                                {$t('Contract Start Date')} <span className="text-danger">*</span>
                                            </label>
                                            <FormikDatePickerField name="contract_started_at" />
                                            {errors.contract_started_at && touched.contract_started_at && (
                                                <div className="text-danger">{errors.contract_started_at}</div>
                                            )}
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <label htmlFor="contract_ended_at">
                                                {$t('Contract Ended Date')} <span className="text-danger">*</span>
                                            </label>
                                            <FormikDatePickerField name="contract_ended_at" />
                                            {errors.contract_ended_at && touched.contract_ended_at && (
                                                <div className="text-danger">{errors.contract_ended_at}</div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <Button variant="secondary" data-dismiss="modal" aria-label="Close" disabled={isSubmitting}>
                                        {$t('Cancel')}
                                    </Button>
                                    <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting}>
                                        {$t('Save')}
                                    </Button>
                                </div>
                            </>
                        )}
                    </Formik>
                )}
            </div>
        </div>
    );
}

if (document.getElementById('sponsorCommitmentModal')) {
    var root = document.getElementById('sponsorCommitmentModal');
    ReactDOM.render(
        <App>
            <SponsorCommitmentModal />
        </App>,
        root,
    );
}
